export const PageLoadingTracerName = 'PageLoadingTracer';
export const PageLoadingSpanAttribute = 'workflow.name';
